// extracted by mini-css-extract-plugin
export var productImage = "_mk-0";